export const version = "local" as string;
